
const axios = require('axios');

//
export default {

	getDeal(context, slug) {
		return new Promise((resolve, reject) => {

			// axios.post(`https://armslist.deals/v1/api`, { action: 'getDeal', slug: slug })
			axios.get(`https://api.armslist.deals/v1/deals`, { params: { slug: slug } })
				.then(res => {
					try {
						resolve(res.data.data[0]);
					}catch(e) {
						reject(e);
					}
				})
				.catch(e => reject(e.response.data.error.message));

		});
	},

	getDeals(context, params) {
		return new Promise((resolve, reject) => {

			// axios.post(`https://armslist.deals/v1/api`, { params: Object.assign({}, params, { action: 'getDeals' }) })
			axios.get(`https://api.armslist.deals/v1/deals`, { params: params })
				.then(res => resolve(res.data))
				.catch(e => reject(e.response.data.error.message));

		});
	}

};